import React, { Component } from "react";
import InputField from "../../elements/Input";
import MasterService from "../../../service/MasterService";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Select from "react-select";
import secureStorage from '../../../config/encrypt';
import { NumericFormat as NumberFormat } from "react-number-format";

class IFViewCategoryManagement extends Component {
    constructor(props) {
        super(props);
        console.log(props, 'test')
        this.state = {
            adminUserData: props.adminUserData,
            isEdit: props.isEdit,
            feeType: [{
                value:1,
                label:"Percentage Value"
            },{
                value:2,
                label:"Flat Numeric Value"
            }],
            adminFeeTypeSuffix: '%',
            renewalFeeTypeSuffix: '%',
            riskPremiumFeeTypeSuffix: '%',
            repeatOrderFeeTypeSuffix: '%',
            bpkbSwitchFeeTypeSuffix: '%',
            principalRepaymentFeeTypeSuffix: '%',
            formData: props.formData || {},
            errors: {},
            loading: false
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            adminUserData: nextProps.adminUserData,
            isEdit: nextProps.isEdit,
            formData: nextProps.formData,
        });
    }

    handleInputField = (event, keyName) => {
        let formData = this.state.formData;
        let errors = this.state.errors;
        if(keyName === 'category_name'){
            formData[keyName] = event.target.value;
        }else if(keyName === 'renewal_time' || keyName === 'loan_tenure'){//
            const validated = event.target.value.match(/^[0-9]+$/)
            if(validated){
                formData[keyName] = event.target.value;
            }else{
                formData[keyName] = 0;
            }
        }else if(keyName === 'penalty_fee'){
            const validated = event.value.match(/^(?!0(\.0+)?$)\d*(\.\d{0,2})?$/);
            formData[keyName] = validated ? event.value : '';
        } else{
            const validated = event.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/)
            if(validated){
                formData[keyName] = event.target.value;
            } 
        }
        delete errors[keyName];
        this.setState({ errors})

    };

    handleChange = (data, name) => {
        const feeTypes = {
            admin_fee_type: 'adminFeeTypeSuffix',
            renewal_fee_type: 'renewalFeeTypeSuffix',
            risk_premium_type: 'riskPremiumFeeTypeSuffix',
            repeat_order_fee_type: 'repeatOrderFeeTypeSuffix',
            bpkb_switch_fee_type: 'bpkbSwitchFeeTypeSuffix',
            principal_repayment_fee_type: 'principalRepaymentFeeTypeSuffix',
        };

        this.setState(prevState => {
            const formData = {
                ...prevState.formData,
                [name]: data.value
            };

            const errors = {
                ...prevState.errors
            };
            delete errors[name];

            const suffixUpdates = {};
            if (name in feeTypes) {
                suffixUpdates[feeTypes[name]] = data?.value === 1 ? '%' : '';
            }

            return {
                formData,
                errors,
                ...suffixUpdates
            };
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ loading: true })
        if (this.validForm()) {
        MasterService.post("/dealer/inventory-funding/save_if_category_list", {
            ...this.state.formData,
            ltv:this.state.formData.ltv === '' ? null : this.state.formData.ltv,
            created_by: this.state.adminUserData.user_id,
            updated_by: this.state.adminUserData.user_id,
        })
            .then((response) => {
                if (response && response.data && response.data.status === 200) {
                    toast.success("Data saved successfully");
                    this.handleModelClose();
                    this.setState({ loading: false })
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.message);
                }
            })
            .catch((error) => {
                this.handleModelClose();
                this.setState({ loading: false })
                toast.error(error);
            });
        }else{
            this.setState({ loading: false })
        }
    };

    validForm = () => {
        let fields = this.state.formData;
         let formIsValid = true;
         let errors = { ...this.state.errors };
        if (!fields["category_name"]) {
            errors['category_name'] =   this.props.t('Listing.IF_VALIDATION.Category_Name');
            formIsValid = false;
        }
        if (!fields["interest_fee"]) {
            errors['interest_fee'] =   this.props.t('Listing.IF_VALIDATION.Interest_Fee');
            formIsValid = false;
        }
        if (!fields["provision_fee"]) {
            errors['provision_fee'] =   this.props.t('Listing.IF_VALIDATION.Provision_Fee');
            formIsValid = false;
        }
        if (!fields["admin_fee"]) {
            errors['admin_fee'] =   this.props.t('Listing.IF_VALIDATION.Admin_Fee');
            formIsValid = false;
        }
        if (!fields["renewal_fee"]) {
            errors['renewal_fee'] =   this.props.t('Listing.IF_VALIDATION.Renewal_Fee');
            formIsValid = false;
        }
        if (!fields["risk_premium_fee"]) {
            errors['risk_premium_fee'] =   this.props.t('Listing.IF_VALIDATION.risk_premium_fee');
            formIsValid = false;
        }
        if (!fields["repeat_order_fee"]) {
            errors['repeat_order_fee'] = this.props.t('Listing.IF_VALIDATION.repeat_order_fee');
            formIsValid = false;
        }
        if (!fields["bpkb_switch_fee"]) {
            errors['bpkb_switch_fee'] = this.props.t('Listing.IF_VALIDATION.bpkb_switch_fee');
            formIsValid = false;
        }
        if (!fields["principal_repayment_fee"]) {
            errors['principal_repayment_fee'] = this.props.t('Listing.IF_VALIDATION.principal_repayment_fee');
            formIsValid = false;
        }
        if (!fields["renewal_time"]) {
            errors['renewal_time'] =   this.props.t('Listing.IF_VALIDATION.Renewal_Time');
            formIsValid = false;
        }
        if (!fields["loan_tenure"]) {
            errors['loan_tenure'] =   this.props.t('Listing.IF_VALIDATION.Loan_Tenure');
            formIsValid = false;
        }
        if (!fields["penalty_fee"]) {
            errors['penalty_fee'] =   this.props.t('Listing.IF_VALIDATION.Penalty_Fee');
            formIsValid = false;
        }
        if (!fields["penalty_interest"]) {
            errors['penalty_interest'] =   this.props.t('Listing.IF_VALIDATION.Penalty_Interest');
            formIsValid = false;
        }

        if (fields["admin_fee"] !== '' && fields?.["admin_fee_type"] === 1) {
            if(fields["admin_fee"] > 100){
                errors['admin_fee'] =  this.props.t('Listing.IF_VALIDATION.Admin_Fee_Type');
                formIsValid = false;
            }
        }

        if (fields["risk_premium_fee"] !== '' && fields?.["risk_premium_type"] === 1) {
            if(fields["risk_premium_fee"] > 100){
                errors['risk_premium_fee'] =  this.props.t('Listing.IF_VALIDATION.Risk_premium_Fee_Type');
                formIsValid = false;
            }
        }

        if (fields["repeat_order_fee"] !== '' && fields?.["repeat_order_fee_type"] === 1) {
            if (fields["repeat_order_fee"] > 100) {
                errors['repeat_order_fee'] = this.props.t('Listing.IF_VALIDATION.repeat_order_fee_type');
                formIsValid = false;
            }
        }

        if (fields["bpkb_switch_fee"] !== '' && fields?.["bpkb_switch_fee_type"] === 1) {
            if (fields["bpkb_switch_fee"] > 100) {
                errors['bpkb_switch_fee'] = this.props.t('Listing.IF_VALIDATION.bpkb_switch_fee_type');
                formIsValid = false;
            }
        }

        if (fields["risk_premium_fee"] !== '' && fields?.["principal_repayment_fee_type"] === 1) {
            if (fields["principal_repayment_fee"] > 100) {
                errors['principal_repayment_fee'] = this.props.t('Listing.IF_VALIDATION.principal_repayment_fee_type');
                formIsValid = false;
            }
        }

        if (fields["admin_fee"] !== '' && fields?.["admin_fee_type"] === 2) {
            if(fields["admin_fee"] > 99999999){
                errors['admin_fee'] =  this.props.t('Listing.IF_VALIDATION.Admin_Fee_val');
                formIsValid = false;
            }
        }

        if (fields["renewal_fee"] !== '' && fields?.["renewal_fee_type"] === 1) {
            if(fields["renewal_fee"] > 100){
                errors['renewal_fee'] =  this.props.t('Listing.IF_VALIDATION.Admin_Fee_Type');
                formIsValid = false;
            }
        }

        if (fields["renewal_fee"] !== '' && fields?.["renewal_fee_type"] === 2) {
            if(fields["renewal_fee"] > 99999999){
                errors['renewal_fee'] =  this.props.t('Listing.IF_VALIDATION.Admin_Fee_val');
                formIsValid = false;
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleModelClose = () => {
        if (this.state.isEdit) {
            this.props.closeIfEditCategoryModel();
        } else {
            this.props.closeIfAddCategoryModel();
        }
    };

    render() {
        const { formData, errors } = this.state;
        formData['admin_fee_type'] = this?.state?.formData?.admin_fee_type ? this.state.formData.admin_fee_type: 1
        formData['renewal_fee_type'] = this?.state?.formData?.renewal_fee_type ? this.state.formData.renewal_fee_type: 1
        // let css = "";//need to remove below three lines as var css not in use
        // if (errors) {
        //     css = `.form-error {display:block}`;
        // }
        let role_access = []
        if (secureStorage.getItem('loginUserInfo')) {
            let loginResponse = secureStorage.getItem('loginUserInfo');
            // eslint-disable-next-line no-unused-vars
            role_access = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.role_data && loginResponse.data.user_data.role_data.length > 0 ? loginResponse.data.user_data.role_data : []
        }

        return (
            <div className={this.state.loading ? "container-fluid loading" : "container-fluid"}>
                <form className="text-left os-animation animated fadeInDown">
                    <div className="row form-group">
                        <div className="col-sm-4 ">
                            <InputField
                                type="text"
                                error={""}
                                name="category_name"     
                                id="category_name"
                                placeholder={this.props.t("Listing.IF_Add_Category.Category_Name")}
                                value={this.state.formData.category_name}
                                label={this.props.t("Listing.IF_Add_Category.Category_Name")}
                                maxLength={40}
                                onChange={(e) => {
                                    this.handleInputField(e, 'category_name');
                                }}
                                required={true}
                                
                            />
                            {
                                (errors && errors.category_name) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.category_name}</span> : ''
                            }
                        </div>
                    </div>
                    <div className="row">
                        {[
                            { key: "Interest_Fee", type: "number", suffix: '%', min: 0, max: 100 },
                            { key: "Provision_Fee", type: "number", suffix: '%', min: 0, max: 100 },
                            { key: "Admin_Fee_Type", type: "select", suffix: '' },
                            { key: "Admin_Fee", type: "number", suffix: this.state.adminFeeTypeSuffix },
                            { key: "Renewal_Fee_Type", type: "select", suffix: '' },
                            { key: "Renewal_Fee", type: "number", suffix: this.state.renewalFeeTypeSuffix },
                            { key: "Renewal_Time", type: "text", suffix: 'Days', max: 1000000 },
                            { key: "Loan_Tenure", type: "text", suffix: 'Days', max: 1000000 },
                            { key: "Penalty_Interest", type: "number", suffix: '%', min: 0, max: 100 },
                            { key: "Penalty_Fee", type: "number", suffix: 'Per Day', min: 0, max: 10000000000 },
                            { key: "ltv", type: "number", suffix: '%', min: 0, max: 100 },
                            { key: "category_cashback", type: "number", suffix: '%', min: 0, max: 100 },
                            { key: "risk_premium_type", type: "select", suffix: '' },
                            { key: "risk_premium_fee", type: "number", suffix: this.state.riskPremiumFeeTypeSuffix },
                            { key: "repeat_order_fee_type", type: "select", suffix: '' },
                            { key: "repeat_order_fee", type: "number", suffix: this.state.repeatOrderFeeTypeSuffix },
                            { key: "bpkb_switch_fee_type", type: "select", suffix: '' },
                            { key: "bpkb_switch_fee", type: "number", suffix: this.state.bpkbSwitchFeeTypeSuffix },
                            { key: "principal_repayment_fee_type", type: "select", suffix: '' },
                            { key: "principal_repayment_fee", type: "number", suffix: this.state.principalRepaymentFeeTypeSuffix },
                        ].map((field, index) => {
                            const lowerCaseKey = field.key.toLowerCase();
                            const translatedPlaceholder = this.props.t(`Listing.IF_Add_Category.${field.key}`);
                            if (['Penalty_Fee'].includes(field.key)) {
                                return (<div className="col-sm-3 mrg-b5" key={index}>
                                    <label>{`${translatedPlaceholder} ${field.suffix ? `(${field.suffix})` : ''}`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name={lowerCaseKey}
                                        id={lowerCaseKey}
                                        placeholder={translatedPlaceholder}
                                        value={parseFloat(this.state.formData[lowerCaseKey]) || ""}
                                        label={`${translatedPlaceholder} ${field.suffix ? `(${field.suffix})` : ''}`}
                                        onValueChange={(e) => {
                                            this.handleInputField(e, lowerCaseKey);
                                        }}
                                    />
                                    {
                                        (errors && errors[lowerCaseKey]) ? <span className="error show">{errors[lowerCaseKey]}</span> : ''
                                    }
                                </div>)
                            } else if (['Admin_Fee_Type', 'Renewal_Fee_Type' ,'risk_premium_type','repeat_order_fee_type','bpkb_switch_fee_type','principal_repayment_fee_type'].includes(field.key)) {
                                return (<div className="col-sm-3 mrg-b5" key={index}>
                                    <label>{translatedPlaceholder}</label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        name={lowerCaseKey}
                                        id={lowerCaseKey}
                                        options={this.state.feeType}
                                        onChange={(data) => {
                                            this.handleChange(data, lowerCaseKey);
                                        }}
                                        placeholder={translatedPlaceholder}
                                        value={this.state.feeType.filter(({ value }) => value === this.state.formData[lowerCaseKey])}
                                        getOptionLabel={({ label }) => label}
                                        getOptionValue={({ value }) => value}
                                    />
                                </div>)
                            } else {
                                return (<div className="col-sm-3 mrg-b5" key={index}>
                                    <InputField
                                        min={field.min}
                                        max={field.max}
                                        type={field.type}
                                        maxLength={field.max}
                                        error={""}
                                        name={lowerCaseKey}
                                        id={lowerCaseKey}
                                        placeholder={translatedPlaceholder}
                                        value={this.state.formData[lowerCaseKey] || ""}
                                        label={`${translatedPlaceholder} ${field.suffix ? `(${field.suffix})` : ''}`}
                                        onChange={(e) => {
                                            this.handleInputField(e, lowerCaseKey);
                                        }}
                                        required= {['ltv','category_cashback'].includes(field.key) ? false: true}
                                    />
                                    {
                                        (errors && errors[lowerCaseKey]) ? <span className="error show" style={{ "marginTop": "-13px", "lineHeight": "1px" }}>{errors[lowerCaseKey]}</span> : ''
                                    }
                                </div>)
                            }

                        })}
                    </div>

                    {/* <div className="row">
                        <div className="col-sm-6 col-md-12 form-group text-center">
                            {
                               role_access.includes("inventory_funding_category_save") &&
                                <Button
                                    onClick={this.handleSubmit}
                                    colclass="col-sm-12"
                                    btnClass="btn btn-primary mrg-r15"
                                    type="submit"
                                    name="addleadbtn"
                                    id="cancel"
                                    title={this.props.t("Listing.IF_Add_Category.Save_Details")}
                                />
                            }
                        </div>
                    </div> */}
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth_token: state.authToken,
        user_loggedin: state.userLoggedIn,
        dealer_id: state.dealer_id,
    };
};

export default withTranslation("inventory_funding")(connect(mapStateToProps)(IFViewCategoryManagement));
